import { lazy } from 'react';

const CustomerSettingsConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
  },
  routes: [
    {
      path: '/customersettings',
      component: lazy(() => import('./CustomerSettings')),
    },
  ],
};

export default CustomerSettingsConfig;
